
import axios from 'axios'
import _URL from '../../URL/index';

export default {
    services: {
        createSurcharge: (surcharge) => {
            return axios.post(`${_URL._API}/surcharges`, surcharge);
        },
        getSurchargeById: (surchargeId) => {
            return axios.get(`${_URL._API}/surcharges/${surchargeId}`);
        },
        updateSurchargeById: (surchargeId, surcharge) => {
            return axios.put(`${_URL._API}/surcharges/${surchargeId}`, surcharge);
        },
        deleteSurchargeById: (surchargeId) => {
            return axios.delete(`${_URL._API}/surcharges/${surchargeId}`)
        },
        updateAnyAttributeById:(surchargeId, payload) =>{
            return axios.patch(`${_URL._API}/surcharges/${surchargeId}`, payload);
        }    
    }
}